import { FC, SVGProps } from 'react';

export const FlameIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M7.99925 14.4001C5.35255 14.4001 3.19922 12.372 3.19922 9.87924C3.19922 6.4001 7.99929 1.6001 7.99929 1.6001C7.99929 1.6001 12.7992 6.4001 12.7992 9.87924C12.7992 12.3721 10.646 14.4001 7.99925 14.4001ZM7.99925 14.4001C6.6759 14.4001 5.59922 13.3861 5.59922 12.1397C5.59922 10.4001 7.99925 8.0001 7.99925 8.0001C7.99925 8.0001 10.3992 10.4001 10.3992 12.1397C10.3992 13.3861 9.32261 14.4001 7.99925 14.4001Z" stroke="#F7B055" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);
